import { FieldDef } from 'app/core/models';
import { InputOutput } from 'app/layout/layout.service';
import { RelatedToType } from 'app/shared/enums';
import { Dictionary } from 'app/shared/models/dictionary';
import { Observable } from 'rxjs';

type CustomFormSaveAction = (formValue: Dictionary<any>, extraData?: Dictionary<any>) => void;
type CustomFormBeforeSaveAction = (formValue: Dictionary<any>) => Observable<boolean>;

export interface CustomFormOptions extends InputOutput {
  inputs: {
    initialValue?: any;
    allowedFields: FieldDef[];
    selectedFields: CustomField[] | CustomField[][];
    dataSources: Dictionary<any>;
    commonData?: Dictionary<any>;
    relatedToType?: RelatedToType;
    renderAttachFileField?: boolean;
    canEditLayout?: boolean;
    saveAction: CustomFormSaveAction;
    beforeSaveAction?: CustomFormBeforeSaveAction;
    enableEditing?: boolean;
  };
  outputs: {
    onTemplateChanged?: (currentFields: CustomField[][]) => void;
    onNavigationByUrlRequested?: (url: string) => void;
  };
}

export interface CustomField {
  name: string;
  isRequired?: boolean;
  isRemovable?: boolean;
}

export interface CustomFormField extends CustomField {
  name: string;
  type?: CustomFormFieldType;
  fieldDef?: FieldDef;
}

export enum CustomFormFieldType {
  FieldDef = 'fieldDef',
  Custom = 'custom',
  Placeholder = 'placeholder',
}

export type AddressBase = {
  id?: number;
  place_id?: string;
  address_string?: string;
  street_address?: string;
  street?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  latitude?: number;
  longitude?: number;
};

export type CustomAddressFieldValue = {
  property?: {
    name?: string;
    address: AddressBase;
  };
  address?: AddressBase;
  // Some endpoints / models still expect flattened address fields at the top-level (e.g. Contacts).
  address_string?: string | null;
  street_address?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export function isFlatCustomFieldArray(arr: CustomField[] | CustomField[][]): arr is CustomField[] {
  return arr.length === 0 || !Array.isArray(arr[0]);
}

export { CustomFormSaveAction, CustomFormBeforeSaveAction };
